import { memo } from 'react';
import { FooterNavLinksBlock } from './components/FooterNavLinksBlock';
import { FooterPaymentMethodsBlock } from './components/FooterPaymentMethodsBlock';
import { FooterLicenseBlock } from './components/FooterLicenseBlock';
import { FooterCopyrightBlock } from './components/FooterCopyrightBlock';
import { Wrapper } from '../../../components/Wrapper/Wrapper';
import { FooterSeoBlock } from './FooterSeoBlock';

const SEPARATOR_STYLES = 'w-full border-t-1 border-f_separator';

const _Footer = () => {
  return (
    <footer className="w-full flex flex-col items-center justify-center bg-f_bg pb-10 pt-8">
      <Wrapper>
        <FooterNavLinksBlock />
        <div className={SEPARATOR_STYLES} />
        <FooterPaymentMethodsBlock />
        <div className={SEPARATOR_STYLES}></div>
        <FooterSeoBlock />
        <FooterLicenseBlock />
        <FooterCopyrightBlock />
      </Wrapper>
    </footer>
  );
};

export const Footer = memo(_Footer);
